export const GetAllPayment_REQUEST = "GetAllPayment_REQUEST";
export const GetAllPayment_SUCCESS = "GetAllPayment_SUCCESS";
export const GetAllPayment_FAIL = "GetAllPayment_FAIL";

export const AddPayment_REQUEST = "AddPayment_REQUEST";
export const AddPayment_SUCCESS = "AddPayment_SUCCESS";
export const AddPayment_FAIL = "AddPayment_FAIL";


export const GetPaymentByOrderID_REQUEST = "GetPaymentByOrderID_REQUEST";
export const GetPaymentByOrderID_SUCCESS = "GetPaymentByOrderID_SUCCESS";
export const GetPaymentByOrderID_FAIL = "GetPaymentByOrderID_FAIL";

export const GetOrderPending_REQUEST = "GetOrderPending_REQUEST";
export const GetOrderPending_SUCCESS = "GetOrderPending_SUCCESS";
export const GetOrderPending_FAIL = "GetOrderPending_FAIL";